import React, { useState, useEffect } from "react";
import { Menu, Table, Skeleton } from "antd";
import moment from "moment";
import { getSearchFilter,getDateSorter, } from "../../utils/filterHelper";
import { getData } from "../../config/api-connect";

const OtherRevenueSummary = ({ venue_id, sport, month, year }) => {
  const [currentTab, setCurrentTab] = useState("list");
  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState([]);

  useEffect(() => {
    getCustomerList();
  }, [month, year, sport]);

  const getCustomerList = () => {
    if (!sport) return;

    setLoading(true);

    getData(
      `/business/get_revenue_customers/?month=${month}&year=${year}&venue_id=${venue_id}&sport=${sport}`
    )
      .then((response) => {
        setCustomerData(response.result || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "Customer",
      dataIndex: "customer",
      ...getSearchFilter("customer", "Customer"),
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      ...getSearchFilter("mobile", "Mobile"),
    },
    {
      title: "Package",
      dataIndex: "package",
      ...getSearchFilter("package", "Package"),
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      ...getDateSorter("start_date"),
      render: (text) => (text ? moment(text).format("DD MMM YYYY") : "-"),
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      ...getDateSorter("end_date"),
      render: (text) => (text ? moment(text).format("DD MMM YYYY") : "-"),
    },
    {
      title: "Revenue",
      dataIndex: "revenue",
      align: "right",
      sorter: (a, b) => a.revenue - b.revenue,
      render: (value) => `₹${value.toLocaleString("en-IN")}`,
    },
  ];

  return (
    <div style={{ padding: 10 }}>
      <Menu
        selectedKeys={[currentTab]}
        mode="horizontal"
        items={[{ key: "list", label: "List" }]}
      />

      <div style={{ marginTop: "1%" }}>
        {loading ? (
          <Skeleton active paragraph={{ rows: 8 }} />
        ) : (
          <>
            <div className="recordCount">{customerData.length} records</div>

            <Table
              className="drill-down-table table_container"
              rowKey={(record, index) => index}
              columns={columns}
              dataSource={customerData}
              pagination={{ pageSize: 50, showSizeChanger: false }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default OtherRevenueSummary;